import { Component, EventEmitter, inject, OnInit } from '@angular/core';
import { OrderDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { IOverlayService, IOverlayServiceToken } from 'shared/services/ui/overlay/overlay-service.interface';

@Component({
  template: '',
  standalone: false
})
export class OrderCheckoutResultDialogBaseComponent implements OnInit {
  private readonly overlayService: IOverlayService = inject(IOverlayServiceToken);
  public orderList: OrderDto[] | undefined;
  public modalClose: EventEmitter<void> = new EventEmitter();

  public ngOnInit(): void {
    this.overlayService.isOverlayVisibleSet(false);
  }

  public close() {
    this.modalClose.emit();
  }

}
